import { call } from "redux-saga/effects"
import { DLogin } from "apis/DLogin"
import { moveToTop } from "locale"

export function* handlingGetApiError(error) {
  if (error.message === "invalid token") {
    // リフレッシュトークンが無効な場合
    yield call(DLogin, { prompt: false })
  } else if (error.message === "dauth error") {
    // サーバエラーなどでトークンリフレッシュに失敗した場合
    yield call(moveToTop)
  } else {
    // APIの処理に失敗した場合
    yield call(moveToTop)
  }
}

export function* handlingPutApiError(error) {
  if (error.message === "invalid token") {
    // リフレッシュトークンが無効な場合
    yield call(DLogin, { prompt: true })
  } else if (error.message === "dauth error") {
    // サーバエラーなどでトークンリフレッシュに失敗した場合
    yield call(moveToTop)
  } else {
    // APIの処理に失敗した場合
    yield call(moveToTop)
  }
}
